export const ADMIN_PANEL = 'AdminPanel';
export const ADMIN_PANEL_LOGIN = 'AdminPanelLogin';
export const ADMIN_PANEL_RESET_PASSWORD = 'AdminPanelResetPassword';
export const ADMIN_PANEL_EMPLOYEES = 'AdminPanelEmployees';
export const ADMIN_PANEL_EMPLOYEE = 'AdminPanelEmployee';
export const ADMIN_PANEL_CLIENTS = 'AdminPanelClients';
export const ADMIN_PANEL_CLIENT = 'AdminPanelClient';
export const ADMIN_PANEL_PROFILE = 'AdminPanelProfile';
